import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Button, Row, Col, Spin } from 'antd';
import history from './../../../../../services/history';
import ChannelTableProhibitedItem from './channel-table-prohihited-items';
import lang from './../../../../../languages/en';
import HeaderItemNameProhibited from './header-prohibited-item-name';
import RowsProhibitedItems from './../prohibited-items/rows-prohibited-items/index';
import handleException from './../../../../../services/handleException';
import { alertError, alertSuccess, confirmChangeItem, showConfirm } from './../../../../../services/dialog';
import deteleConfirmDialog from '../deteleConfirmDialog';
import { ListChannel } from './../../../../../constants/setting_channel';
import './styles.css';
import ToolbarItemProhibited from './ToolbarItemProhibited';
import { onChangeDisplayContentQuestion, onChangeDisplayContentWarning } from './../../../../../actions/prohibitedItems';
import { getListProhibitedItems as getListProhibitedItemsAxios } from "./../../../../../utils/prohibitedItems";


const initialFilterState = {
    sku: '',
    itemCode: '',
    itemNameEn: '',
    itemNameJp: '',
    countryOfOrigin: '',
    hasApprove: false,
    keywordSearch: null,
}

class ProhibitedItems extends Component {
    constructor(props) {
        super(props);
        this.initDataLoadPage();
        let { channelActive } = this.props.match.params;
        this.state = {
            isLoading: true,
            checkedAll: false,
            collectIdItem: [],
            collectIdItemCurrent: [],
            fileName: null,
            itemNameData: [],
            channelActive: channelActive,
            isFilterVisible: false,
            isImportVisible: false,
            checkChangeOnce: true,
            isEdit: false,
            checkErrorInput: false,
            dataImport: {
                countCreate: 0,
                countDelete: 0,
                countEdit: 0
            },
            pagination: {
                countItemName: 0,
                currentPage: 1,
                pageSize: 20,
                pageCount: 0
            },
            filterValues: {
                ...initialFilterState
            },
            editItemMaster: false,
            checkErrorInput: false,
            LineNumberHasProhibited: null,
            NumberProhibited: null,
            ProhibitedModel: [],
        }
    }
    componentWillUnmount() {
        // document.getElementById('setting-merchant').classList.remove("list-item");

    }

    onchangeLineNumberHasProhibited = (number) => {
        this.setState({
            LineNumberHasProhibited: number
        })
    }

    onchangeNumberProhibited = (number) => {
        this.setState({
            NumberProhibited: number
        })
    }

    onchangeProhibitedModel = (ProhibitedModel) => {
        this.setState({
            ProhibitedModel: ProhibitedModel
        })
    }
    handleLoading = (value) => {
        return this.setState({
            isLoading: value
        })
    }

    inforPagination = (pagination) => {
        this.setState({
            pagination
        })
    }

    handlePagination = (currentPage) => {
        const { pagination: { pageSize }, channelActive, filterValues, sortParams } = this.state
        return new Promise((resolve, reject) => {
            this.setState({
                pagination: {
                    ...this.state.pagination,
                    currentPage
                }
            }, async () => {
                await this.loadData(currentPage, pageSize, channelActive, filterValues, sortParams)
                resolve('done')
            })
        })
    }

    changePagination = (currentPage, size) => {
        if (this.state.checkErrorInput) {
            return alertError(lang.field_some_required)
        }
        if (this.state.isEdit) {
            confirmChangeItem(lang.confirm_save_item_name,
                () => {
                    let data = {
                        type: 'saveChangePaginate',
                        currentPage,
                        size
                    }
                    this.refRows.saveItemName(data)
                },
                () => {
                    const { filterValues, pagination, channelActive } = this.state
                    this.loadData(currentPage, pagination.pageSize, channelActive, filterValues)
                })
        } else {
            this.handlePagination(currentPage)
        }
    }

    checkAllWhenActivePagination = () => {
        const { collectIdItemCurrent, collectIdItem } = this.state
        let checkAll = true

        if (!collectIdItemCurrent.length) return;
        collectIdItemCurrent.map(e => {
            if (collectIdItem.indexOf(e) === -1) {
                checkAll = false
            }
            return false;
        })
        this.setState({
            checkedAll: checkAll
        })
    }

    loadData = (currentPage, pageSize, channelActive, filterValues, sortParams) => {
        this.refRows.loadData(currentPage, pageSize, channelActive, filterValues, sortParams)
    }

    collectIdItemCurrent = (value) => {
        this.setState({
            collectIdItemCurrent: value
        }, () => {
            this.checkAllWhenActivePagination()
        })
    }

    selectChannel = (channel_id) => {
        this.setState({
            channelActive: channel_id,
            filterValues: {
                ...initialFilterState
            }
        })
    }

    initDataLoadPage = () => {
        let _this = this;
        getListProhibitedItemsAxios().then((res) => {
            if (res.data.code === 10001) {
                _this.setState({
                    prohibitedItems: res.data.data.ProhibitedKeyWords
                })
            } else {
                handleException(res)
            }
            _this.loadDataSearch();
        }).catch(err => {
            handleException(err);
            _this.loadDataSearch();
        })
    }

    loadDataSearch = () => {
        const { sortParams } = this.state
        if (this.refRows) {
            this.refRows.loadData(1, this.state.pagination.pageSize, this.state.channelActive, sortParams)
        }

    }

    shortChannel = (shortChannel) => {
        this.setState({
            shortChannel
        })
        for (let key in ListChannel) {
            let itemChannel = ListChannel[key];
            if (shortChannel === itemChannel.ShortName) {
                this.setState({
                    fileNameExportItemMaster: itemChannel.NameFileExportItemMaster
                })
                break;
            }
        }
    }

    onChangePageSize = (e) => {
        if (this.state.checkErrorInput) {
            return alertError(lang.field_some_required)
        }
        if (this.state.isEdit) {
            this.popUpConfirmSave(null, null,
                () => this.handleOnChangePageSize(e),
                () => this.handleOnChangePageSize(e))
        } else {
            this.handleOnChangePageSize(e)
        }
    }

    handleOnChangePageSize = (e) => {
        const { filterValues, sortParams } = this.state

        this.setState({
            pagination: {
                ...this.state.pagination,
                pageSize: e
            }
        })

        this.loadData(this.state.pagination.currentPage, e, this.state.channelActive, filterValues, sortParams)
    }

    toggleFilter = () => {
        this.setState({
            isFilterVisible: !this.state.isFilterVisible
        })
    }

    onResetFilter = () => {
        const { channelActive, pagination: { pageSize, currentPage }, sortParams } = this.state
        // clear filter input
        this.setState({
            filterValues: {
                ...initialFilterState
            }
        })
        //reload list
        this.loadData(currentPage, pageSize, channelActive, sortParams)
    }

    onFilterChange = e => {
        let { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            value = checked;
        }
        this.setState({
            filterValues: {
                ...this.state.filterValues,
                [name]: value
            }
        })
    }

    saveItemName = () => {
        this.refRows.saveItemName()
    }

    onChangeHasApprove = (value) => {
        const { channelActive, pagination: { pageSize, currentPage } } = this.state
        let filterValues = {
            ...this.state.filterValues,
            hasApprove: value
        }
        this.setState({
            filterValues
        })
        if (this.state.isEdit) {
            confirmChangeItem(lang.confirm_save_item_name,
                () => {
                    let data = {
                        currentPage,
                        pageSize,
                        channelActive,
                        filterValues,
                        type: "applyFilter"
                    }
                    this.refRows.saveItemName(data)
                }, () => this.loadData(1, pageSize, channelActive, filterValues))
        } else {
            this.loadData(1, pageSize, channelActive, filterValues)
        }
    }

    onChangeKeywordSearch = (keywordSearch) => {
        if (keywordSearch === 'All') {
            keywordSearch = null
        }
        const { channelActive, pagination: { pageSize, currentPage } } = this.state
        let filterValues = {
            ...this.state.filterValues,
            keywordSearch: keywordSearch
        }
        this.setState({
            filterValues
        })
        if (this.state.isEdit) {
            confirmChangeItem(lang.confirm_save_item_name,
                () => {
                    let data = {
                        currentPage,
                        pageSize,
                        channelActive,
                        filterValues,
                        type: "applyFilter"
                    }
                    this.refRows.saveItemName(data)
                }, () => this.loadData(1, pageSize, channelActive, filterValues))
        } else {
            this.loadData(1, pageSize, channelActive, filterValues)
        }
    }

    isEditItemFuns = (name, value) => {
        this.setState({
            [name]: value
        })
    }

    popUpConfirmSave = (loadData = false, typeSave = null, callback, cancel) => {
        return new Promise((rs, rj) => {
            confirmChangeItem(lang.confirm_save_item_name, () => {
                this.refRows.saveItemName(typeSave, !loadData, callback)
                rs('done')
            }, () => {
                const { pagination, channelActive } = this.state
                loadData && this.loadData(pagination.currentPage, pagination.pageSize, channelActive)
                cancel && typeof cancel === 'function' && cancel()
                rs('done')
            })
        })
    }

    checkErrorInput = (value) => {
        this.setState({
            checkErrorInput: value
        })
    }

    onShowSizeChange = (current, pageSize) => {
    }

    onCloseProhibitedItems = () => {
        if (this.state.checkErrorInput) {
            return alertError(lang.field_some_required)
        }
        if (this.state.isEdit) {
            this.popUpConfirmSave(null, null,
                () => history.push('/setting/merchant'),
                () => history.push('/setting/merchant'))
        } else {
            history.push('/setting/merchant')
        }
    }

    onChangeCheckedAll = (valueCheckox) => {
        this.setState({
            checkedAll: valueCheckox
        })
    }

    render() {
        return (
            <React.Fragment>
                <div id="prohibited-items" className="screen-prohibited-items">
                    <div className="title-prohibited-items">Prohibited Item Keyword Check</div>
                    <Icon className='close-prohibited-items' onClick={this.onCloseProhibitedItems} type="close" theme="outlined" />

                    <div className='title-prohibited-items-detail'>
                        <div>
                            <span className="title-detail">Prohibited Item Master</span>
                        </div>
                        <div>
                            <span className="icon-prohibited-items">
                                <ChannelTableProhibitedItem
                                    selectChannel={this.selectChannel}
                                    shortChannel={this.shortChannel}
                                    isEdit={this.props.isEdit}
                                    popUpConfirmSave={this.props.popUpConfirmSave}
                                    channelActive={this.state.channelActive}
                                    checkErrorInput={this.props.checkErrorInput}
                                />
                            </span>
                        </div>
                    </div>

                    {
                        parseInt(this.props.displayContentWarningProhibited) ?
                            <div className="content-warning">
                                <span className="box-warring">
                                    <Icon type="exclamation" className="icon-warning warning" />
                                </span>
                                <p className="title-warning">
                                    {lang.content_warning}
                                </p>
                                <a className="icon-close-warning" onClick={e => this.props.onChangeDisplayContentWarning(0)} ><Icon type="close" ></Icon></a>
                            </div>
                            : ''
                    }

                    <Spin spinning={this.state.isLoading} tip='Loading...'>

                        <Row id="maintenacne-content">
                            <Col id="setting-content" className="left-col" span={24}>
                                <div className="table-header">
                                    <ToolbarItemProhibited
                                        NumberProhibited={this.state.NumberProhibited}
                                        LineNumberHasProhibited={this.state.LineNumberHasProhibited}
                                        ProhibitedModel={this.state.ProhibitedModel}
                                        onChangeHasApprove={this.onChangeHasApprove}
                                        onChangeKeywordSearch={this.onChangeKeywordSearch}
                                        keywordSearch={this.state.filterValues.keywordSearch}
                                        checkButtonDelete={this.checkButtonDelete}
                                        saveItemName={this.saveItemName}
                                        selectChannel={this.selectChannel}
                                        deleteItemName={this.deleteItemName}
                                        toggleFilter={this.toggleFilter}
                                        changePagination={this.changePagination}
                                        onChangePageSize={this.onChangePageSize}
                                        shortChannel={this.shortChannel}
                                        popUpConfirmSave={this.popUpConfirmSave}
                                        isFilterVisible={this.state.isFilterVisible}
                                        pagination={this.state.pagination}
                                        channelActive={this.state.channelActive}
                                        isEdit={this.state.isEdit}
                                        collectIdItemCurrent={this.state.collectIdItemCurrent}
                                        checkErrorInput={this.state.checkErrorInput}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <div className="prohibited-table">
                            <Row>
                                <Col className="right-col" span={24}>
                                    <div className="table-operations">
                                        <table className='table-merchant-setting'>
                                            <HeaderItemNameProhibited
                                                sortParams={this.state.sortParams}
                                                onChangeCheckedAll={this.onChangeCheckedAll}
                                                valueCheckox={this.state.checkedAll}
                                                idItemName={this.state.collectIdItem}
                                                handleSort={this.handleSort}
                                                collectIdItemCurrent={this.state.collectIdItemCurrent}
                                                NumberProhibited={this.state.NumberProhibited}
                                            />

                                            <RowsProhibitedItems
                                                checkedAll={this.state.checkedAll}
                                                onChangeCheckedAll={this.onChangeCheckedAll}
                                                onchangeProhibitedModel={this.onchangeProhibitedModel}
                                                onchangeLineNumberHasProhibited={this.onchangeLineNumberHasProhibited}
                                                onchangeNumberProhibited={this.onchangeNumberProhibited}
                                                handleLoading={this.handleLoading}
                                                collectIdItem={this.collectIdItem}
                                                ref={e => this.refRows = e}
                                                collectIdItemCurrent={this.collectIdItemCurrent}
                                                inforPagination={this.inforPagination}
                                                isEditItemFuns={this.isEditItemFuns}
                                                handlePagination={this.handlePagination}
                                                checkErrorInput={this.checkErrorInput}
                                                updateEditingRow={this.updateEditingRow}
                                                saveItemName={this.saveItemName}
                                                idItemName={this.state.collectIdItem}
                                                pagination={this.state.pagination}
                                                collectIdItemCurrentValue={this.state.collectIdItemCurrent}
                                                channelActive={this.state.channelActive}
                                                isEdit={this.state.isEdit}
                                                checkChangeOnce={this.state.checkChangeOnce}
                                                filterValues={this.state.filterValues}
                                                currentShortChannel={this.state.shortChannel}
                                                prohibitedItems={this.state.prohibitedItems}
                                                onChangeKeywordSearch={this.onChangeKeywordSearch}
                                                keywordSearch={this.state.filterValues.keywordSearch}
                                            />

                                        </table>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Spin>
                </div>
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        displayContentWarningProhibited: state.prohibitedItems.displayContentWarningProhibited,
    }
}

const mapDispatchToProp = (dispatch) => {
    return {
        onChangeDisplayContentWarning: payload => {
            dispatch(onChangeDisplayContentWarning(payload))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProp
)(ProhibitedItems)



// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/prohibited-items/index.js